<template>
  <v-app>
    <v-container class="page-root pa-0 ma-0 d-flex flex-column">
      <v-container class="pa-0 ma-0 d-flex flex-column gap-12">
        <!-- scroll vertically and horizentally && productdetails for one of  -->
        <v-container v-if="!showCart && !showCheckout && !success" class="pa-0 ma-0">
          <ProductScrollVertical
            v-if="!open && !showCart && !showCheckout && !success && hash"
            @paymentDetails="handlePaymentDetails"
            @headerData="handleHeaderData"
            @selectProduct="selectProduct"
            @open="open = true"
            @add="addToCart"
            @remove="removeFromCart"
            :cartItems="cartItems"
            :shopHash="hash"
            :shopuid="cuid"
          />
          <ProductDetails
            v-if="open && !showCart && !showCheckout && !success"
            :product="selectedProduct"
            :cartItems="cartItems"
            @add="addToCart"
            @remove="removeFromCart"
            @close="handleCloseDetails"
          />
        </v-container>
        <!-- sticky cart section -->
        <StickyCart
          v-if="!showCart && !showCheckout && !success"
          @open-cart="showCart = true"
          :totalCount="totalCount"
          :totalPrice="totalPrice"
        />

        <!-- cart page -->
        <v-container v-if="showCart && !showCheckout && !success" class="pa-0 ma-0">
          <Cart
            :cartItems="cartItems"
            :totalPrice="totalPrice"
            @close="showCart = false"
            @add="addToCart"
            @itemTotals="itemTotalsHandler"
            @remove="removeFromCart"
            @go-checkout="goToCheckout"
          />
        </v-container>

        <!-- checkout page -->
        <v-container v-if="showCheckout && !success" class="pa-0 ma-0">
          <PaymentPage
            :cartItems="cartItems"
            :totalPrice="totalPrice"
            :totalPerProduct="totalPerProduct"
            :paymentObject="paymentDetails"
            @SuccessObject="handleSuccess"
            @close="handleClosePeyment"
          />
        </v-container>
        <!-- finally page -->
        <PaymentSuccess
          v-if="success"
          :successArray="InvoiceID"
          :shopuid="cuid"
          :headerData="headerInfo"
        />
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
import Header from './partial/Header.vue'
import ProductScrollVertical from './partial/ProductScrollVertical.vue'
import ProductDetails from './partial/ProductDetails.vue'
import StickyCart from './partial/StickyCart'
import Cart from './partial/Cart'
import PaymentPage from './partial/PaymentPage'
import PaymentSuccess from './partial/PaymentSuccess'

export default {
  name: 'HomeShop',
  components: {
    Header,
    ProductScrollVertical,
    ProductDetails,
    StickyCart,
    Cart,
    PaymentPage,
    PaymentSuccess
  },
  data: () => ({
    showCart: false,
    showCheckout: false,
    cartItems: [],
    paymentDetails: [],
    selectedProduct: null,
    InvoiceID: {},
    headerInfo: [],
    hash: null,
    cuid: null,
    open: false,
    success: false,
    totalPerProduct: null
  }),
  computed: {
    totalCount () {
      return this.cartItems.reduce((sum, item) => sum + item.count, 0)
    },
    totalPrice () {
      return this.cartItems.reduce((sum, item) => {
        const price = Number(String(item.price).replace(/,/g, '')) || 0
        return sum + price * item.count
      }, 0)
    }
  },

  mounted () {
    this.cuid = this.$route.params.uid
    this.hash = this.$route.params.hash
    this.loadSelectedProduct()
  },
  watch: {
    showCart (newVal) {}
  },
  methods: {
    itemTotalsHandler (value) {
      this.totalPerProduct = value
    },
    // ADD_ITEM
    addToCart (product) {
      const existing = this.cartItems.find((p) => p.id === product.id)

      if (existing) {
        existing.count++
      } else {
        this.cartItems.push({ ...product, count: 1 })
      }
    },
    // DECREASE_ITEM
    removeFromCart (product) {
      const existing = this.cartItems.find((p) => p.id === product.id)
      if (!existing) return

      if (existing.count > 1) {
        existing.count--
      } else {
        this.cartItems = this.cartItems.filter((p) => p.id !== product.id)
      }
    },
    // SET_SELECTED_PRODUCT
    selectProduct (product) {
      this.selectedProduct = product
      if (product) {
        localStorage.setItem('selectedProduct', JSON.stringify(product))
      } else {
        localStorage.removeItem('selectedProduct')
      }
    },
    // LOAD_SELECTED_PRODUCT
    loadSelectedProduct () {
      const product = localStorage.getItem('selectedProduct')
      if (product) {
        this.selectedProduct = JSON.parse(product)
      }
    },
    // go to cart page
    goToCheckout () {
      this.showCart = false
      this.showCheckout = true
    },
    // close peyment page back to cart
    handleClosePeyment () {
      this.showCheckout = false
      this.showCart = true
    },
    // close details page
    handleCloseDetails () {
      this.open = false
      this.selectedProduct = null
    },
    // handle object peyment details
    handlePaymentDetails (values) {
      this.paymentDetails = values
    },
    // handle object data header
    handleHeaderData (data) {
      this.headerInfo = data
    },
    // handle object success
    handleSuccess (val) {
      this.cartItems = []
      this.showCheckout = false
      this.InvoiceID = val
      this.success = true
    }
  }
}
</script>

<style scoped>
.page-root {
  min-width: 340px !important;
  margin: 0 auto !important;
  max-width: 600px !important;
  box-sizing: border-box;
}
</style>
